import React from "react";
import { AlertCircle } from "lucide-react";
import { suggestionEmail } from "../lib/emailCheck";

// Avertissement discret sous un champ e-mail : « Vouliez-vous dire … ? » avec correction en
// un clic. N'empêche jamais l'envoi du formulaire.
export const EmailSuggestion = ({ value, onFix, testid }) => {
  const suggestion = suggestionEmail(value);
  if (!suggestion) return null;
  return (
    <div
      className="text-xs mt-1.5 flex items-start gap-1.5 leading-snug"
      style={{ color: "#B45309" }}
      data-testid={testid}
    >
      <AlertCircle size={14} className="shrink-0 mt-0.5" />
      <span>
        Vouliez-vous dire{" "}
        <button
          type="button"
          onClick={() => onFix(suggestion)}
          data-testid={`${testid}-fix`}
          className="font-semibold underline decoration-dotted"
          style={{ color: "#B45309" }}
        >
          {suggestion}
        </button>{" "}
        ? Sans adresse valide, tu ne recevras pas la confirmation.
      </span>
    </div>
  );
};
